export function parseIsoToDateInput(iso: string | null | undefined): string {
  if (!iso) {
    return '';
  }
  return iso.split('T')[0];
}

/** Date-only input → ISO datetime at 00:00 UTC */
export function dateInputToIso(date: string): string | null {
  if (!date) {
    return null;
  }
  return `${date}T00:00:00.000Z`;
}

export function formatWellDate(dateString: string | null | undefined): string {
  if (!dateString) {
    return '-';
  }
  return new Date(dateString).toLocaleDateString('ru-RU');
}
